/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var $header = $( '.col-navbar-header' ),
      $whiteLayer = $( '.white-logo-layer' ),
      $menusWithChildren = $( '.menu-topo .menu-item-has-children' ),
      $pagerVitrine = $( '.bx-pager-facex' ),
      $wVitrine = $( '.w-vitrine' ),
      $menuMobile = $( '.w-menu-mobile' );

  // Adjusts the white layer to cover the part of the logo on the main menu
  function adjustWhiteLayerOnMainMenu() {
    $whiteLayer.width( Math.ceil( $header.offset().left ) );
    $whiteLayer.css( { left: -$whiteLayer.width() } );
  }

  // Fix the display flex on Chrome. The height 100% does'n works properly in there. So, we adjust the height
  // manually if is not a phone (XS)
  function adjustVideosWrapperHomeHeight() {
    var $window = $( window ),
        minHeightVideoWrapper = 284;
    // Only adjusts the height for non-mobile devices
    if ( $window.width() >= 765 ) {
      var finalHeight = null;
      if ( $( window ).width() <= 992 ) {

      } else {
        // These sum is needed because of the margin-top of the next item
        finalHeight = $( '.w-cards-noticias-home' ).outerHeight( true ) + 40;
      }
    }
    $window.on( 'resize', function() {
      if ( $window.width() < 992 ) {
        $( '.destaques-direita' ).height( 'auto' );
      }
    } );
  }

  // Adjusts the position of the pager
  function repositionPager() {
    $pagerVitrine.css( {
      top : ( $wVitrine.outerHeight() / 2 ) - ( $pagerVitrine.outerHeight() / 2 ),
      left: $( '.col-navbar-header' ).offset().left
    } );
  }

  // Centralizes the social networks block for SM devices
  function adjustSizeSocialNetworksBlock() {
    var $blocosRedesHome = $( '.blocos-redes' ),
        totalWidth = 0,
        $redes = $( '.blocos-redes .w-rede' );
    $redes.each( function( index, el ) {
      totalWidth += $( el ).outerWidth( true );
    } );
    $blocosRedesHome.outerWidth( totalWidth );
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        var currentSubmenuSelector,
            $currentSubmenuObject;

        $menusWithChildren.on( 'mouseover', function() {
          currentSubmenuSelector = $( this ).data( 'submenu-selector' );
          $currentSubmenuObject = currentSubmenuSelector ? $( '.' + currentSubmenuSelector ) : null;

          // We fallback on the .sub-menu children in case of data-submenu-selector is not defined.
          if ( ! $currentSubmenuObject ) {
            $currentSubmenuObject = $( this ).find( '.sub-menu' );
          }
          $( this ).addClass( 'active' );
          $currentSubmenuObject.addClass( 'active' );
        } ).on( 'mouseleave', function() { 
          $( this ).removeClass( 'active' );
          $currentSubmenuObject.removeClass( 'active' );
        } );

        objectFitImages( 'img.img-lista-miniatura' );

        $( window ).on( 'resize', adjustWhiteLayerOnMainMenu ).resize();
        if ( $( window ).width() >= 768 ) {
          $( document ).ready( adjustSizeSocialNetworksBlock );
        }

        // Configures the collapsible mobile menus
        $( '.nav-menu-mobile .sub-menu' ).addClass( 'collapse' );
        $( '.nav-menu-mobile .menu-item-has-children a' ).on( 'click', function( e ) {
          $( e.target ).toggleClass( 'active' ).parent().find( '.sub-menu' ).toggleClass( 'collapse' );
        } );

        // Configuring the height of the menu.
        $( '.w-itens-menu-mobile' ).height(
            $( window ).height() -
            ( $( '.w-header-menu-mobile' ).outerHeight() + $( '.w-servicos-matricula' ).outerHeight() )
        );
        // Mobile menu triggers
        $( '.btn-abrir-menu-mobile' ).on( 'click', function( e ) {
          e.preventDefault();
          $menuMobile.addClass( 'active' );
          $( 'body' ).css( 'overflow', 'hidden' );
        } );

        $( '.btn-fechar-menu-mobile' ).on( 'click', function( e ) {
          e.preventDefault();
          $menuMobile.removeClass( 'active' );
          $( 'body' ).css( 'overflow', 'auto' );
        } );
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $( '.vitrines' ).bxSlider( {
          useCss: true,
          controls: false,
          pagerCustom: '.bx-pager-facex',
          auto: true,
          pause: 5000
        } );

        if ( $( window ).width() > 768 ) {
          $( '.galerias-container' ).bxSlider( {
            useCss: true,
            controls: true,
            pager: false,
            nextText: "",
            prevText: "",
            auto: true,
            pause: 5000
          } );
        }

        $( document ).ready( adjustVideosWrapperHomeHeight );
        $( window ).on( 'resize', $.throttle( 600, repositionPager ) ).resize();
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // :O
    'page_template_template_home_internas_ensino': {
      init: function() {
        $( '.vitrines' ).bxSlider( {
          useCss: true,
          auto: true,
          pause: 4000,
          controls: false
        } );
      }
    },
    'single_galeria': {
      init: function() {
        $( '.w-fotos' ).bxSlider( {
          useCss: true,
          auto: true,
          pause: 4000,
          nextText: '',
          prevText: '',
          controls: true
        } );
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
